export const TYPES = {
  //group
  SET_OPEN_ADD_GROUP: "var/SET_OPEN_ADD_GROUP",
  SET_OPEN_EDIT_GROUP: "var/SET_OPEN_EDIT_GROUP",
  SELECT_DETAIL_GROUP: "var/SELECT_DETAIL_GROUP",

  //service
  SELECT_DETAIL_SERVICE: "var/SELECT_DETAIL_SERVICE",
  SET_OPEN_ADD_SERVICE: "var/SET_OPEN_ADD_SERVICE",
  SET_OPEN_EDIT_SERVICE: "var/SET_OPEN_EDIT_SERVICE",

  //job
  SET_OPEN_RECEIPT: "var/SET_OPEN_RECEIPT",
  SET_OPEN_DETAIL_RECEIPT: "var/SET_OPEN_DETAIL_RECEIPT",
  SELECT_RECORD_JOB_SUCCESS: "var/SELECT_RECORD_JOB_SUCCESS",
  SELECT_JOB_SERVICE_SUCCESS: "var/SELECT_JOB_SERVICE_SUCCESS",

  //search
  SET_SEARCH: "var/SET_SEARCH",

  //gift
  SET_GIFT: "var/SET_GIFT",

  //staff
  SET_STAFF: "var/SET_STAFF",

  //joblist
  SET_ASSIGN_STAFF: "var/SET_ASSIGN_STAFF",
  SET_JOB: "var/SET_JOB",

  //step
  SET_STEP: "var/SET_STEP",

  //feedback:
  SET_FEEDBACK: "var/SET_FEEDBACK",
  SET_FEED_STAFF: "var/SET_FEED_STAFF",

  //incomeStaff
  SET_DATE: "var/SET_DATE",
  SET_LABEL_DATE: "var/SET_LABEL_DATE",
  IGNORE_SELECT_JOB: "var/IGNORE_SELECT_JOB",
};
